export const GET_AUCTION_DETAILS =
  "[Auction Get] Get Auction Details (Supplier)";
export const REFRESH_LIVE_BIDDING_DATA_SUPPLIER =
  "[Live Bidding Data Refresh] refresh live bidding data (Supplier)";
export const REFRESH_LIVE_AUCTION_SUPPLIER =
  "[Live Auction Refresh] refresh live Auction Props (Supplier)";
